const NAME_EDU = {
  "Teh Bunga Telang":
    "Dikenal memiliki antioksidan alami dan cocok untuk minuman relaksasi ringan.",
  "Teh Rosela Merah":
    "Dikenal mengandung vitamin C alami dengan rasa segar yang menyenangkan.",
};

/**
 * Returns a short edu note for select herbal products (telang & rosela).
 * Falls back to the product's own eduNote field if provided.
 */
export const getProductEduNote = (product) => {
  if (!product) return null;
  if (product.eduNote) return product.eduNote;
  return NAME_EDU[product.name] || null;
};
